// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"45":"TabsFilter","90":"wix-bookings-services-preferences-modal","342":"DropdownFilter","662":"TagsFilter"}[chunkId] || chunkId) + ".chunk.min.js";
};